<template>
  <div id="app">
    <header class="head">
      <a class="back tl" href="javascript:history.back(-1)">
        <i class="el-icon-arrow-left"></i>
      </a>
      <a href="javascript:;" class="font-size: 18px;text-align: center;">
        <small class="font_18 co_f">违法行为查处</small>
      </a>
    </header>
    <main>
      <div class="notedetail">
        <div class="article-title" style="font-size: 18px;text-align: center;">
          {{optionsa[this.Detail.item].label}}
        </div>
        <article v-html="this.Detail.contentStr">
        </article>
      </div>
    </main>
  </div>
</template>

<script type="text/ecmascript-6">
  import {
    SubjectCreditRewardPunish
  } from '../../api/api';
  export default {
    data() {
      return {
        optionsa: [{
            value: '1',
            label: "行政处罚"
          },
          {
            value: '2',
            label: "移送司法机关处理记录"
          },
          {
            value: '3',
            label: "政府部门、行业协会对企业的表彰奖励、典型示范、行业推荐"
          }
        ],
        Detail: {},
        PageSize: 10,
        CriteriaList: []
      };
    },
    methods: {
      goback() {
        window.history.back()
      },
      getData() {

        this.CriteriaList[0] = {
          Name: "enterprise.unid",
          Value: "%" + JSON.parse(
            sessionStorage.getItem("WapEnterpriseUnid")
          ).unid + "%",
          Operate: "Like",
          DataType: null,
          EndSuffix: "",
          Suffix: null
        };
        this.CriteriaList[1] = {
          Name: "unid",
          Value: "%" + this.$route.query.unid + "%",
          Operate: "Like",
          DataType: null,
          EndSuffix: "",
          Suffix: null
        };
        let varQueryData = {
          pageSize: this.PageSize,
          currentPage: 1,
          query: {
            criteriaList: this.CriteriaList,
          }
        };
        let options = {
          params: {
            queryData: JSON.stringify(varQueryData),
          }
        };
        //调取接口
        SubjectCreditRewardPunish(options).then((res) => {
          if (res.success === true) {
            this.Detail = res.data.data[0]
            // console.log(this.Detail);
            
          }
        })
      },
    },
    //页面加载时候
    created() {
      this.getData()

    }

  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss" scoped>
  .notedetail {
    padding: 0px 10px;

    .article-title {
      h2 {
        color: #333
      }
    }

    span {
      color: #999;

      i {
        vertical-align: text-bottom;
        margin-right: 5px;
      }
    }

    article {
      margin-top: 10px;
      text-indent: 2rem;
      line-height: 1.5rem;
      font-size: 1rem;
    }
  }

</style>



// WEBPACK FOOTER //
// RewardPunish.vue?4988e7e8